import Link from "../link";
import style from "./style.scss";

import { useId } from "preact/hooks";
import { usePopup } from "../popup/context";
import Popup from "../popup";
import Editorial from "../editorial";

const PopupLink = ({ text, title, children }) => {
  const popup = usePopup();
  const modalTitleId = useId();

  const openDetails = (e) => {
    e.preventDefault();

    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            {title && <h2 id={modalTitleId}>{title}</h2>}
            {children}
          </Editorial>
        </div>
      </Popup>
    );
  };
  return (
    <Link href="#" onClick={(e) => openDetails(e)}>
      {text}
    </Link>
  );
};

export default PopupLink;
